import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Lege staat (design-skill: layout-patterns.md). Titel + één zin + hooguit
 * twee acties; icoon in een cirkelmerk met oranje stip. Geen grappen of emoji.
 */
export function EmptyState(props: {
  icon: LucideIcon;
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  const Icon = props.icon;
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border border-dashed px-6 py-12 text-center">
      <div
        className="relative grid size-24 place-items-center rounded-full bg-muted"
        aria-hidden="true"
      >
        <Icon className="size-9 text-muted-foreground" strokeWidth={1.75} />
        <span className="absolute top-3 right-3 size-3 rounded-full bg-primary ring-4 ring-background" />
      </div>
      <h2 className="text-h3 font-semibold">{props.title}</h2>
      {props.description && (
        <p className="max-w-[40ch] text-muted-foreground">{props.description}</p>
      )}
      {props.actions && <div className="flex flex-wrap justify-center gap-2">{props.actions}</div>}
    </div>
  );
}
